import { TestBarActions, TestBarActionTypes } from '@ispm/test/store/test-bar.actions';

export interface ITestBarState {
  confirmButtonEnabled: boolean;
  confirmButtonAvailable: boolean;
  confirmButtonTooltip?: string | null;
}

const initialState: ITestBarState = {
  confirmButtonEnabled: false,
  confirmButtonAvailable: true,
  confirmButtonTooltip: null
};

export function testBarReducer(state = initialState, action): ITestBarState {
  switch (action.type) {
    case TestBarActionTypes.EnableConfirmButton:
      return { ...state, confirmButtonEnabled: action.payload,  };
    case TestBarActionTypes.AvailableConfirmButton:
      return { ...state, confirmButtonAvailable: action.payload };
    case TestBarActionTypes.EnableConfirmButtonTooltip:
      return { ...state, confirmButtonTooltip: action.payload };
    default:
      return state;
  }
}
